
import { Button } from '../../ui/button';


interface QuizNavigationProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  isMultiSelect: boolean;
  selectedOption: string | null;
  selectedOptions: string[];
  requiredSelections: number;
  tableReady: boolean;
  onNextQuestion: () => void;
}

const QuizNavigation = ({
  currentQuestionIndex,
  totalQuestions,
  isMultiSelect,
  selectedOption,
  selectedOptions,
  requiredSelections,
  tableReady,
  onNextQuestion
}: QuizNavigationProps) => {
  const isDisabled = isMultiSelect 
    ? selectedOptions.length !== requiredSelections 
    : !selectedOption;

  return (
    <>
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <img 
            src="/lovable-uploads/clr_4.png" 
            alt="Bromentum Logo" 
            className="w-8 h-8 object-contain"
          />
          <span>Question {currentQuestionIndex + 1} of {totalQuestions}</span>
        </div>
        
        <Button
          onClick={onNextQuestion}
          disabled={isDisabled || !tableReady}
          className="bg-tan text-navy hover:bg-tan-dark disabled:opacity-50"
        >
          {currentQuestionIndex < totalQuestions - 1 ? 'Next Question' : 'Submit'}
        </Button>
      </div>
      
      {!tableReady && (
        <p className="text-amber-400 mt-4 text-center">Setting up database, please wait...</p>
      )}
    </>
  );
};

export default QuizNavigation;
